import React from 'react'
import { CartIcon } from '../Icons/icons'
import "./CartToggleButton.css"
import { useSelector } from 'react-redux';


const CartToggleButton = ({ toggleCart }) => {
     const {cartSubTotalAmount, cartTotalItems} = useSelector( state => state.cart)
  return (
    <div
      className="cart-toggle-btn position-fixed top-50 end-0 translate-middle-y z-3 shadow border-0 rounded-start px-3 py-2 d-flex align-items-center bg-primary text-white cursor-pointer"
      title="Open your shopping cart"
      onClick={toggleCart}
      style={{ cursor: "pointer" }}
    >
      <CartIcon width={22} height={22} className="me-2 text-white" />
      <div>
        <small className='fw-bold'>{cartTotalItems} Items</small>
        <hr className="my-1 bg-light opacity-50" />
        <small className="fw-semibold">৳ {cartSubTotalAmount}</small>
      </div>
    </div>
  )
}

export default CartToggleButton
